export default __webpack_public_path__ + "static/media/foilIcon.6ee054f0.png";